import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import ServicePlans from './ServicePlans';
import messages from '../../../locale/jsonMessages';


export default async function action({ store, intl }) {

    const title = intl?.formatMessage(messages.servicePlanLabel);

    // From Redux Store
    let isAdminAuthenticated = store?.getState()?.runtime?.isAdminAuthenticated;
    const adminPrivileges = store?.getState()?.account?.privileges && store?.getState()?.account?.privileges?.privileges;
    const privileges = store?.getState()?.listSettings && store?.getState()?.listSettings?.privileges;
    const isServicePlanEnabled = store?.getState()?.siteSettings?.data?.isServicePlanEnabled

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    if(isServicePlanEnabled == 'false'){
        return { redirect: '/siteadmin' };
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/service-plans', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout><ServicePlans title={title} /></AdminLayout>,
    };

};
